import React, { useState } from "react";
import { useDispatch } from "react-redux";

import "../../Widgets/WidgetsSettings/FormV3/settings.less";
import { setWidgetInSheetParams } from "../../../appRedux/actions/Boards";
import IntlMessages from "../../../util/IntlMessages";
import { Button, Input } from "../../BP2Components";

type QuestionnaireSettingsValue = {
   formId?: string;
   questionnaireId?: string;
   [key: string]: unknown;
};

type Props = {
   value: QuestionnaireSettingsValue;
};

const QuestionnaireSettings: React.FC<Props> = ({ value }) => {
   const dispatch = useDispatch();

   const [settings, setSettings] = useState<QuestionnaireSettingsValue>({ ...value });

   const handleSubmit = () => {
      dispatch(setWidgetInSheetParams(settings));
   };

   const handleChangeInput = (name: string, e: React.ChangeEvent<HTMLInputElement>) => {
      setSettings({ ...settings, [name]: e.target.value });
   };

   return (
      <div className="questionnaire-settings-container">
         <div className="questionnaire-option-container">
            <span style={{ width: "100px" }}>
               <IntlMessages id="settings.questionnaireId" />
            </span>
            <Input
               type="text"
               name="questionnaireId"
               value={settings.questionnaireId ?? ""}
               onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeInput("questionnaireId", e)
               }
               style={{ width: "200px" }}
            />
         </div>
         <Button
            key="formv3-settings-save-btn"
            buttonType="primary"
            onClick={handleSubmit}
            style={{ float: "right" }}
         >
            <IntlMessages id="global.preview" />
         </Button>
      </div>
   );
};

export default QuestionnaireSettings;
